module.exports = __webpack_public_path__ + "img/finance.61d61024.svg";